import React from 'react';

const RefundPolicy = () => {
  return (
    <div className='bg-gray-100'>
      <div className="max-w-5xl mx-auto px-4 py-10 bg-gray-100">
        <h2 className=" text-3xl font-semibold text-gray-800 mb-4">UrbanCab Partner Cancellation & Refund Policy</h2>
        <p className=" text-sm text-gray-500 mb-6">Effective Date: 20-06-2025</p>

        <p className="text-sm text-gray-700 mb-4">
          At UrbanCab Partner, we aim to provide a smooth and transparent cab booking experience. Please review our cancellation and refund policy carefully before booking a ride.
        </p>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Ride Cancellation Policy</h3>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">By User:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li><strong>Before Driver Assignment:</strong> Users can cancel the ride free of charge if no driver has been assigned.</li>
          <li><strong>After Driver Assignment:</strong> A cancellation fee may be applicable if the driver is already on the way.</li>
          <li><strong>No-show:</strong> If the rider does not show up at the pickup point within 10 minutes of the driver's arrival, the ride will be auto cancelled, and the full fare or cancellation fee may apply.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">By Driver:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>Drivers may cancel a ride due to unforeseen circumstances. Repeated cancellations are reviewed by UrbanCab Partner's quality team.</li>
          <li>If a driver cancels, users will not be charged and may rebook instantly.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Cancellation Charges:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>₹0 if cancelled before driver assignment.</li>
          <li>25% of charges if cancelled after driver assignment.</li>
          <li>20% fare in case of No-show (both user & driver).</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Refund Policy</h3>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Eligible Refunds:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>If the ride was cancelled due to driver unavailability.</li>
          <li>For prepaid bookings cancelled within the allowed time.</li>
          <li>If the user was wrongly charged due to technical issues.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Refund Processing:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>Refunds are processed to the original payment method within 5-7 business days.</li>
          <li>Wallet/top-up credits are non-refundable but can be reused for future rides.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Exceptions:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>Surge pricing or traffic delays are not valid reasons for a refund.</li>
          <li>UrbanCab Partner may deny refund requests that are fraudulent, abusive, or violate Terms of Service.</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">UrbanCab Partner – Cancellation and Refund Policy</h3>
        <p className="text-sm text-gray-500 mb-6">Last updated: 20-06-2025</p>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">User Cancellations</h4>
        <p className="text-sm text-gray-700 mb-4">
          You may cancel your booking via the UrbanCab Partner app. If cancellation occurs after driver/vehicle details are shared, a cancellation fee may apply.
        </p>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Confirmation Requirement:</h4>
        <p className="text-sm text-gray-700 mb-4">
          No cancellation fee will apply unless UrbanCab Partner confirms the request as per this policy.
        </p>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Cancellation Charges:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>No charges before driver or vehicle details are shared.</li>
          <li>After that, the user forfeits 20% or full advance amount, whichever is applicable.</li>
          <li>If the driver waits more than 5 minutes and the rider is unresponsive, wait-time fees apply and booking is cancelled.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Driver Cancellations:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>The rider is unresponsive or unreachable.</li>
          <li>The pickup location is unsafe or incorrect.</li>
          <li>The vehicle has a mechanical issue.</li>
          <li>The rider delays beyond the allowed wait time.</li>
          <li>Users are not charged if cancelled by driver for valid reasons.</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Refund Timeline:</h4>
        <p className="text-sm text-gray-700 mb-4">
          Applicable refunds will be initiated within 7–10 business days. Delays due to incorrect user bank/account details are not UrbanCab Partner's responsibility.
        </p>

        <h4 className="text-lg font-semibold text-gray-800 mb-1">Exclusions:</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 mb-4">
          <li>Cash or goods handed to the driver outside the app's system.</li>
          <li>Third-party driver damages or losses, although recovery assistance is offered.</li>
          <li>Misconduct by users toward drivers may lead to forfeited advance and legal action.</li>
        </ul>

        
      <h3 className="text-xl font-semibold mt-4">Contact & Support:</h3>
      <div>
        <p className='text-[18px] font-medium text-gray-500 mb-2'>If you have any questions, contact us:</p>
        <p className=''> <span className=" font-semibold">Legal Name :</span> DIVIRAJ TAXI AND RENTALS PRIVATE LIMITED</p>
        <p className=''> <span className=" font-semibold">Registered Business Address :</span> 675-B, S.NATHPURAM, KOTA, Kota, Rajasthan, 324010</p>
        Email: <a href="mailto:urbancabpartner@gmail.com" className="text-blue-600 underline">urbancabpartner@gmail.com</a>
        <br /> Phone: <a href="tel:+919783966966
 " className="text-blue-600 underline">9783966966
 </a>
      </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
